import { Colors } from '../consts/Colors.js'
import { tags } from '../consts/Tags'
import Button from '../sydo/prefab/buttons/Button'

/**
 * x,y : position du bouton
 * w,h : dimensions du bouton
 * image : image de fond du bouton
 * text : texte du bouton
 * sliceInfos : array avec les info pour les parties fixes de l'image. [left, right, top, bottom]
 */

export default class ButtonImageSliced extends Button {
    constructor(scene, x, y, w, h, image, text, sliceInfos, spec) {
        super(scene, x, y, { text: text, image: image, sliceInfos: sliceInfos, w: w, h: h, spec: spec })
    }

    addBody(params) {
        if (params.sliceInfos == undefined) {
            params.sliceInfos = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            }
        } else {
            if (params.sliceInfos.top == undefined) {
                params.sliceInfos.top = 0
            }
            if (params.sliceInfos.bottom == undefined) {
                params.sliceInfos.bottom = 0
            }
            if (params.sliceInfos.left == undefined) {
                params.sliceInfos.left = 0
            }
            if (params.sliceInfos.right == undefined) {
                params.sliceInfos.right = 0
            }
        }
        // Ajout image de fond
        this.back = this.scene.add.nineslice(0, 0, params.image, 0, params.w, params.h, params.sliceInfos.left, params.sliceInfos.right, params.sliceInfos.top, params.sliceInfos.bottom)
        this.add(this.back)
        let fontSize = '25px'
        let color = Colors.Text.Black

        if (params.spec == "Bigwhite") {
            fontSize = '45px'
            color = Colors.Text.White
        }
        if (params.spec == "Smallwhite") {
            fontSize = '25px'
            color = Colors.Text.White
        }
        this.text = this.scene.add.rexTagText(0, 0, params.text, {
            fontSize: fontSize,
            fontFamily: "CenturyGothic",
            align: "center",
            color: color,
            tags: tags,
            backgroundColor: "transparent",
        }).setOrigin(0.5)
        this.add(this.text)

        this.fx = this.back.postFX.addColorMatrix()

        // Modification de la taille du container
        this.setSize(params.w, params.h);
        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });
        // this.playClick = () => {
        //     this.clickSound.play();
        // };
    }


setClickFunction( clickFunction ){
        this.on('pointerup', () => {
                clickFunction(this);
                this.clickSound.play();
        }, this.scene);
    }

    pointerOver() {
        this.fx.brightness(1.1)
    }

    pointerOut() {
        this.fx.reset()
    }

    setLocked() {
        // Ajout de l'état bloqué
        this.isLocked = true
        this.disableInteractive()
        this.setAlpha(0.5)
    }

    setUnlocked() {
        // Ajout de l'état débloqué
        this.isLocked = false
        this.setInteractive()
        this.setAlpha(1)
    }

    // -- Update Text
    setTextFont(font) {
        this.text.setFontFamily(font)
    }

    setTextSize(size) {
        this.text.setFontSize(size)
    }

    setTextColor(color) {
        this.text.setColor(color)
    }

    setTextContent(content) {
        this.text.setText(content)
    }

    adjustToText(deltaW, deltaH) {
        if ((this.text.width + deltaW) > this.back.width) {
            this.back.width = this.text.width + deltaW
        }
        if ((this.text.height + deltaH) > this.back.height) {
            this.back.height = this.text.height + deltaH
        }
    }
}